module.exports = __webpack_public_path__ + "img/arrow-right-small_w.5189a11a.svg";